import React, { useCallback, useEffect, memo, useState } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import MenuSidebar from "./Components/AdminSidebar";
import AdminHeader from "../Admin/Components/AdminHeader";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faLock,
  faLockOpen,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import {
  blockUserAction,
  getAdminUserListAction,
} from "../../Services/Store/Actions/VanuesAction";
import VenuesSpaceList from "../Admin/Components/VenuesSpaceList";
import AddVenue from "../../Components/Modals/AddVenue";
import { VenueTypes } from "../../Constants/Interfaces";
import { showToast } from "../../utils/helpers";
import PanelWrapper from "../User/PanelWrapper";
import ConfirmationModal from "../../Components/ConfirmationModal";
import ActionMenu from "../../Components/ActionMenu";
import Pagination from "../../Components/Pagination";

const UsersList = () => {
  const dispatch = useDispatch();
  const { usersList } = useSelector((state: any) => state.venues);

  const [loading, setLoading] = useState(false);
  const [adminUsersList, setUsersList] = useState([]);
  const [deletingUser, setDeletingVenue] = useState({});

  const [addNew, setNewVenue] = useState({ show: false, item: {} });

  const [pagination, setPagination] = useState({
    totalItems: null,
    itemsPerPage: null,
    currentPage: null,
    totalPages: null,
    nextPage: null,
  });

  const [showRightPanel, setShowRightPanel] = useState({
    show: false,
    item: {},
  });

  const [blockConfirm, setBlockConfirm] = useState<{
    show: boolean;
    item: any;
  }>({ show: false, item: null });

  const getUserList = useCallback((page = 1) => {
    if (!loading) {
      setLoading(true);

      const data = {
        page,
        limit: 15,
        addresss: "",
        size: "",
        spaces: "",
      };

      getAdminUserListAction(data, dispatch)
        .then((res) => {
          //
          if (res.type === "success") {
            setPagination(res.pagination);
          }
        })
        .catch((err) => {
          //
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  const blockUnBlockUser = (item: { id: string; name: string }) => {
    const userID = item.id;

    if (!deletingUser[userID]) {
      setDeletingVenue({ ...deletingUser, [userID]: true });

      blockUserAction({ id: userID }, dispatch)
        .then((res) => {
          showToast(res.type, res.message);
        })
        .catch((err) => {
          showToast("err", err.message);
        })
        .finally(() =>
          setDeletingVenue({ ...deletingUser, [userID]: false })
        );
    }
  };

  useEffect(() => {
    if (usersList) {
      setUsersList(usersList);
    } else {
      setUsersList([]);
    }
  }, [usersList]);

  useEffect(() => {
    getUserList();
  }, []);

  const [editorData, setEditorData] = useState("<p>Hello, world!</p>");

  return (
    <PanelWrapper type="admin">
      <div className="container">
        <div className="page-header">
          <h2>Users</h2>

          {/* <Button onClick={() => setNewVenue({ show: true, item: {} })}>
                Add New
              </Button> */}
        </div>

        <div className="page-content-card">
          <div className="content-card-header">
            <h3>List of Users</h3>

            {/* <div className="filter-area">
                  <div className="form-group">
                    <select className="form-control">
                      <option>Location</option>
                      <option value="Location1">Location 1</option>
                      <option value="Location2">Location 2</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <select className="form-control">
                      <option>Property Size</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <select className="form-control">
                      <option>Number of Space</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </div>
                </div> */}
          </div>

          <div className="listing-tables">
            <Table responsive>
              <thead>
                <tr>
                  <th>User Name</th>
                  <th>Email</th>

                  <th>Status</th>
                  <th className="action-col">Action</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={4} align="center">
                      <FontAwesomeIcon icon={faSpinner} spin />
                    </td>
                  </tr>
                )}

                {!loading &&
                  (!adminUsersList || adminUsersList.length === 0) && (
                    <tr>
                      <td colSpan={4} align="center">
                        No User Created
                      </td>
                    </tr>
                  )}

                {!loading &&
                  adminUsersList &&
                  adminUsersList.map((item, index) => {
                    return (
                      <tr key={`property-${index}`}>
                        <td
                          className="as-link"
                          // onClick={() => setNewVenue({ show: true, item })}
                        >
                          {item.name}
                        </td>
                        <td>{item?.email}</td>
                        <td>{item?.isVerified ? "Verified" : "Unverified"}</td>
                        <td className="action-col">
                          <div className="d-flex align-items-center justify-content-center">
                            <ActionMenu
                              items={[
                                {
                                  label: item?.blocked ? "Unblock" : "Block",
                                  icon: item?.blocked ? faLock : faLockOpen,
                                  variant: item?.blocked
                                    ? "default"
                                    : "danger",
                                  loading: deletingUser[item.id],
                                  onClick: () =>
                                    setBlockConfirm({ show: true, item }),
                                },
                              ]}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>

              <tfoot>
                <tr>
                  <td colSpan={5}>
                    <Pagination
                      pagination={pagination}
                      onPageChange={(page) => getUserList(page)}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </div>

      {showRightPanel.show && (
        <VenuesSpaceList
          show={showRightPanel.show}
          venue={showRightPanel.item}
          onClose={() => setShowRightPanel({ show: false, item: {} })}
          addNew={false}
        />
      )}

      {addNew.show && (
        <AddVenue
          show={addNew.show}
          item={addNew.item}
          closeModal={() => setNewVenue({ show: false, item: {} })}
        />
      )}

      {blockConfirm.show && (
        <ConfirmationModal
          show={blockConfirm.show}
          heading={
            blockConfirm?.item?.blocked ? "Unblock User" : "Block User"
          }
          message={`Are you sure you want to ${
            blockConfirm?.item?.blocked ? "unblock" : "block"
          } the user ${blockConfirm?.item?.name || ""}?`}
          closeModal={() => setBlockConfirm({ show: false, item: null })}
          buttons={[
            {
              text: "Yes",
              action: () => {
                blockUnBlockUser(blockConfirm.item);
                setBlockConfirm({ show: false, item: null });
              },
            },
            {
              text: "Cancel",
              variant: "outline-dark",
              className: "confirmation-cancel-btn",
              action: () => setBlockConfirm({ show: false, item: null }),
            },
          ]}
        />
      )}
    </PanelWrapper>
  );
};

export default UsersList;
